// SCR-OFF-01 (frozen mockups-off-v1): under the top bar, the Seller sees when there is no signal and how many sales and
// collections wait on the phone; the chip opens the queue. Nothing shows when online with nothing waiting.
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, Notice } from '../../design/kit';
import { useOutbox } from '../../data/offline';
import { useSession } from '../../app/session';

export function OfflineBar() {
  const { t } = useTranslation();
  const { role } = useSession();
  const navigate = useNavigate();
  const box = useOutbox();
  if (role !== 'seller') return null;
  const n = box.items.length;
  if (!box.offline && n === 0) return null;
  const text = box.offline
    ? t(box.overdue ? 'off.warn' : 'off.banner')
    : box.held
      ? t('q.refused')
      : t('off.sending', { n });
  return (
    <div className="yv-skeleton-stack" data-testid="offline-bar">
      <Notice tone={box.overdue || box.held ? 'warning' : 'info'}>{text}</Notice>
      {n > 0 && (
        <Button pill icon="clock" onClick={() => navigate('/round/queue')}>
          {t('off.chip', { n })}
        </Button>
      )}
    </div>
  );
}
